import React from "react";
import { Controller } from "react-hook-form";
import { Form, Select, InputNumber, Table, Switch } from "antd";
import { IndexTagOptions } from "../../../views/Indexes/CreateIndexes";

const { Option } = Select;

const IndexTable = (props) => {
  const { control, watch, dataSource } = props;
  let CUSTOMINDEXES = watch("customIndexes");

  /**
   * define new Constant in the upperscope and extract value types ( Hotels, Report Category, Report Name, Submission Schedule). then refer the constant as necessary.
   *
   */
  const VALUETYPES = [
    {
      IndexName: "Hotels",
      value: "Hotels",
    },
    {
      IndexName: "Report Category",
      value: "Report Category",
    },
    {
      IndexName: "Report Name",
      value: "Report",
    },
    {
      IndexName: "Submission Schedule",
      value: "Submission Schedule",
    },
  ];

  const disableValueTypes = (customIndexes) => {
    const disableValueType = [];
    const disableValueTypes = VALUETYPES.filter((valuetype) => {
      customIndexes.forEach((customIndex) => {
        if (customIndex.name === valuetype.IndexName) {
          if (customIndex.custom_values !== true) {
            disableValueType.push({
              valuetype,
              custom_values: true,
            });
          } else {
            disableValueType.push({
              valuetype,
              custom_values: false,
            });
          }
        }
      });
    });
    return disableValueType;
  };

  // Table column list
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "200px",
    },
    {
      title: "Custom Values",
      dataIndex: "custom_values",
      key: "custom_values",
      width: "130px",
      render: (_, record, index) => (
        <Form.Item>
          <Controller
            control={control}
            name={`customIndexes.${index}.custom_values`}
            render={({ field: { onChange, value } }) => (
              <Switch onChange={onChange} checked={value} />
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: "160px",
      render: (_, record, index) => (
        <Form.Item>
          <Controller
            control={control}
            name={`customIndexes.${index}.type`}
            render={({ field }) => (
              <Select
                disabled={!watch(`customIndexes.${index}.custom_values`)}
                {...field}
              >
                <Option value="Boolean">Boolean</Option>
                <Option value="Date">Date</Option>
                <Option value="Integer">Number</Option>
                <Option value="Double">Double Number</Option>
                <Option value="Text">Text</Option>
                <Option value="Long">Long Text</Option>
              </Select>
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Wildcard",
      dataIndex: "wildcard",
      key: "wildcard",
      width: "100px",
      render: (_, record, index) => (
        <Form.Item>
          <Controller
            control={control}
            name={`customIndexes.${index}.wildcard`}
            render={({ field }) => (
              <InputNumber
                disabled={!watch(`customIndexes.${index}.custom_values`)}
                {...field}
              />
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
      width: "100px",
      render: (_, record, index) => (
        <Form.Item>
          <Controller
            control={control}
            name={`customIndexes.${index}.order`}
            render={({ field }) => (
              <InputNumber
                disabled={!watch(`customIndexes.${index}.custom_values`)}
                {...field}
              />
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Required",
      dataIndex: "required",
      key: "required",
      width: "100px",
      render: (_, record, index) => (
        <Form.Item>
          <Controller
            control={control}
            name={`customIndexes.${index}.required`}
            render={({ field }) => (
              <Select
                disabled={!watch(`customIndexes.${index}.custom_values`)}
                {...field}
              >
                <Option value={true}>True</Option>
                <Option value={false}>False</Option>
              </Select>
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Default Index",
      dataIndex: "defaultIndex",
      key: "defaultIndex",
      width: "150px",
      render: (_, record, index) => (
        <Form.Item>
          <Controller
            control={control}
            name={`customIndexes.${index}.defaultIndex`}
            render={({ field }) => (
              <Select
                disabled={!watch(`customIndexes.${index}.custom_values`)}
                {...field}
              >
                <Option value={true}>True</Option>
                <Option value={false}>False</Option>
              </Select>
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Available In IS",
      dataIndex: "availableInIS",
      key: "availableInIS",
      width: "150px",
      render: (_, record, index) => (
        <Form.Item>
          <Controller
            control={control}
            name={`customIndexes.${index}.availableInIS`}
            render={({ field }) => (
              <Select
                disabled={!watch(`customIndexes.${index}.custom_values`)}
                {...field}
              >
                <Option value={true}>True</Option>
                <Option value={false}>False</Option>
              </Select>
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Tags",
      dataIndex: "tags",
      key: "tags",
      width: "150px",

      render: (_, record, index) => (
        <Form.Item>
          <Controller
            control={control}
            name={`customIndexes.${index}.tags`}
            render={({ field }) => (
              <Select
                mode="tags"
                showArrow
                disabled={!watch(`customIndexes.${index}.custom_values`)}
                {...field}
                style={{ width: "100%" }}
                options={IndexTagOptions}
              />
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Value Type",
      dataIndex: "value_type",
      key: "value_type",
      width: "150px",

      render: (_, record, index) => (
        <Form.Item>
          <Controller
            control={control}
            name={`customIndexes.${index}.value_type`}
            render={({ field }) => (
              <Select
                showArrow
                disabled={!watch(`customIndexes.${index}.custom_values`)}
                {...field}
              >
                <Option value="None">None</Option>
                <Option value="Custom">Custom</Option>
                {disableValueTypes(CUSTOMINDEXES).map((customIndex) => {
                  return (
                    <Option
                      value={customIndex.valuetype.IndexName}
                      disabled={customIndex.custom_values ? true : false}
                    >
                      {customIndex.valuetype.value}
                    </Option>
                  );
                })}
              </Select>
            )}
          />
        </Form.Item>
      ),
    },
    {
      title: "Values",
      dataIndex: "values",
      key: "values",
      width: "200px",
      render: (_, record, index) => (
        <Form.Item>
          <Controller
            control={control}
            name={`customIndexes.${index}.values`}
            render={({ field }) => (
              <Select
                {...field}
                mode="tags"
                notFoundContent={null}
                disabled={
                  watch(`customIndexes.${index}.value_type`) !== "Custom"
                }
                style={{ width: "100%" }}
              />
            )}
          />
        </Form.Item>
      ),
    },
  ];

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      rowKey="_id"
      size="small"
    />
  );
};

export default IndexTable;
